/* Bazan PDP — Recipes toggle + inline How-to reveal panel.
   Click card → clone <template> vào panel dưới grid, scroll tới. Click lại = đóng.
*/
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root._bzInit) return;
    root._bzInit = true;
    root.setAttribute('data-bz-cat', 'vietnamese');

    var panel = root.querySelector('[data-bz-rec-panel]');
    var tabs = root.querySelectorAll('[data-bz-rec-tab]');
    var cards = root.querySelectorAll('.bz-pdp-recipes__card');
    var dots = root.querySelector('[data-bz-rec-dots]');
    var grid = root.querySelector('[data-bz-rec-track]');
    var prevBtn = root.querySelector('[data-bz-rec-prev]');
    var nextBtn = root.querySelector('[data-bz-rec-next]');
    var currentId = null;

    function recStepSize() {
      if (!grid) return 300;
      var vis = visOrigCardsForBtn();
      if (!vis.length) return grid.clientWidth;
      var f = vis[0];
      var s = vis[1];
      var gap = s ? (s.offsetLeft - (f.offsetLeft + f.offsetWidth)) : 0;
      return f.offsetWidth + gap;
    }
    function visOrigCardsForBtn() {
      var cat = root.getAttribute('data-bz-cat') || 'vietnamese';
      return Array.prototype.filter.call(cards, function (c) {
        return c.getAttribute('data-bz-rec-cat') === cat;
      });
    }
    function smoothScrollBy(el, delta) {
      if (el._bzAnim) cancelAnimationFrame(el._bzAnim);
      var start = el.scrollLeft;
      var target = start + delta;
      var lastLeft = start;
      var duration = 450;
      var startT = null;
      function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
      function step(ts) {
        if (startT === null) startT = ts;
        var p = Math.min(1, (ts - startT) / duration);
        // Detect wrap teleport: scrollLeft nhảy lớn giữa 2 frame -> adjust baseline
        var jump = el.scrollLeft - lastLeft;
        if (Math.abs(jump) > 100) {
          start += jump;
          target += jump;
        }
        var newLeft = start + (target - start) * ease(p);
        el.scrollLeft = newLeft;
        lastLeft = newLeft;
        if (p < 1) el._bzAnim = requestAnimationFrame(step);
        else el._bzAnim = null;
      }
      el._bzAnim = requestAnimationFrame(step);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      root._bzUserMoved = true;
      if (grid) smoothScrollBy(grid, -recStepSize());
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      root._bzUserMoved = true;
      if (grid) smoothScrollBy(grid, recStepSize());
    });

    function visibleCardsOf(cat) {
      return Array.prototype.filter.call(cards, function (c) {
        return c.getAttribute('data-bz-rec-cat') === cat;
      });
    }

    function computeVisibleCount(list) {
      if (!grid || !list.length) return 1;
      var containerWidth = grid.clientWidth;
      var cardWidth = list[0].offsetWidth;
      if (!cardWidth) return 1;
      var styles = window.getComputedStyle(grid);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return Math.max(1, Math.floor((containerWidth + gap) / (cardWidth + gap)));
    }

    function updateScrollState(cat) {
      var list = visibleCardsOf(cat);
      var visibleCount = computeVisibleCount(list);
      var shouldScroll = list.length > 1;
      var steps = list.length > visibleCount
        ? Math.max(1, list.length - visibleCount + 1)
        : list.length;
      if (grid) grid.classList.toggle('is-scroll', shouldScroll);

      if (!dots) return;
      dots.innerHTML = '';
      if (!shouldScroll) {
        dots.hidden = true;
        return;
      }
      dots.hidden = false;

      for (var i = 0; i < steps; i++) {
        (function (idx) {
          var card = list[idx];
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'bz-pdp-recipes__dot' + (idx === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Page ' + (idx + 1));
          d.addEventListener('click', function () {
            if (!grid || !card) return;
            grid.scrollTo({ left: card.offsetLeft - grid.offsetLeft, behavior: 'smooth' });
          });
          dots.appendChild(d);
        })(i);
      }
    }

    var lastActiveDot = -1;
    function syncActiveDot() {
      if (!dots || dots.hidden || !grid) return;
      var list = visibleCardsOf(root.getAttribute('data-bz-cat'));
      var dotEls = dots.querySelectorAll('.bz-pdp-recipes__dot');
      if (!dotEls.length) return;
      // Vị trí card lấy từ cache tâm (offsetLeft là layout read) và chỉ ghi
      // class khi index đổi, thay vì toggle mọi dot mỗi frame.
      var cache = centers(), view = snapViewCenter();
      var pos = {};
      for (var c = 0; c < cache.length; c++) pos[cache[c].el.getAttribute('data-bz-rec-id') || c] = cache[c].center;
      var closest = 0, minDist = Infinity;
      for (var i = 0; i < dotEls.length; i++) {
        var card = list[i];
        if (!card) continue;
        var center = pos[card.getAttribute('data-bz-rec-id')];
        if (center == null) continue;
        var d = Math.abs(center - view);
        if (d < minDist) { minDist = d; closest = i; }
      }
      if (closest === lastActiveDot) return;
      if (dotEls[lastActiveDot]) dotEls[lastActiveDot].classList.remove('is-active');
      if (dotEls[closest]) dotEls[closest].classList.add('is-active');
      lastActiveDot = closest;
    }
    window.addEventListener('resize', function () {
      updateScrollState(root.getAttribute('data-bz-cat') || 'vietnamese');
      window.requestAnimationFrame(function () {
        syncActiveDot();
        updateThumb();
      });
    });

    // Query ALL card instances (orig + clones) — dùng khi toggle is-open để sync trạng thái
    // qua tất cả clone, không chỉ orig captured trước setup.
    function allCardInstances() {
      return root.querySelectorAll('.bz-pdp-recipes__card');
    }
    function setOpenById(openId) {
      allCardInstances().forEach(function (c) {
        var isMatch = openId && c.getAttribute('data-bz-rec-id') === openId;
        c.setAttribute('aria-expanded', isMatch ? 'true' : 'false');
        c.classList.toggle('is-open', !!isMatch);
      });
    }

    function closePanel() {
      if (!panel) return;
      panel.removeAttribute('data-open');
      setOpenById(null);
      currentId = null;
      setTimeout(function () {
        if (!panel.hasAttribute('data-open')) {
          panel.hidden = true;
          panel.innerHTML = '';
        }
      }, 500);
    }

    function openPanel(card, skipScroll) {
      if (!panel) return;
      var tpl = card.querySelector('[data-bz-rec-howto]');
      if (!tpl) return;

      var id = card.getAttribute('data-bz-rec-id');
      setOpenById(id);

      panel.innerHTML = '';
      panel.appendChild(tpl.content.cloneNode(true));
      panel.hidden = false;
      requestAnimationFrame(function () {
        panel.setAttribute('data-open', '');
      });

      var closeBtn = panel.querySelector('[data-bz-howto-close]');
      if (closeBtn) closeBtn.addEventListener('click', closePanel);

      var ctaLinks = panel.querySelectorAll('[data-bz-cta]');
      ctaLinks.forEach(function (cta) {
        cta.addEventListener('click', function (e) {
          var href = cta.getAttribute('href') || '';
          if (href.charAt(0) !== '#' || href.length < 2) return;
          var target;
          try { target = document.querySelector(href); } catch (err) { return; }
          if (!target) return;
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.pageYOffset - 60;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
      });

      if (!skipScroll) {
        setTimeout(function () {
          var rect = panel.getBoundingClientRect();
          var panelCenter = rect.top + window.pageYOffset + rect.height / 2;
          var viewCenter = window.innerHeight / 2;
          window.scrollTo({ top: panelCenter - viewCenter - 50, behavior: 'smooth' });
        }, 80);
      }

      currentId = card.getAttribute('data-bz-rec-id');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (root._bzDragged) { root._bzDragged = false; return; }
        var id = card.getAttribute('data-bz-rec-id');
        if (id === currentId) return;
        openPanel(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.click();
        }
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var cat = tab.getAttribute('data-bz-rec-tab');
        root.setAttribute('data-bz-cat', cat);
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        updateScrollState(cat);
        if (root._bzSetupInfinite) root._bzSetupInfinite(cat);
        lastPct = 0;
        updateThumb();
        var firstCard = root.querySelector('.bz-pdp-recipes__card[data-bz-rec-cat="' + cat + '"]:not([data-bz-clone])');
        if (firstCard) openPanel(firstCard, true);
        else closePanel();
      });
    });

    // ---- Infinite (360) scroll BIDIRECTIONAL ----
    function cleanupClones() {
      root.querySelectorAll('.bz-pdp-recipes__card[data-bz-clone="1"]').forEach(function (c) { c.remove(); });
    }
    function visOrigCards(cat) {
      return Array.prototype.filter.call(cards, function (c) {
        return c.getAttribute('data-bz-rec-cat') === cat;
      });
    }
    function setupInfiniteForCat(cat) {
      cleanupClones();
      if (root._bzInvalidateGeo) root._bzInvalidateGeo(); // clone đổi -> geo đổi
      if (!grid) return;
      var vis = visOrigCards(cat);
      if (vis.length <= 1) return;
      // Tắt snap + smooth behavior — cả 2 gây conflict với silent teleport.
      grid.style.scrollSnapType = 'none';
      grid.style.scrollBehavior = 'auto';
      // Clone click -> forward tới orig cùng data-bz-rec-id (scroll xuống panel như orig).
      function attachCloneClick(cloneEl, origCard) {
        cloneEl.addEventListener('click', function (e) {
          e.stopImmediatePropagation();
          e.preventDefault();
          if (root._bzDragged) { root._bzDragged = false; return; }
          var id = origCard.getAttribute('data-bz-rec-id');
          if (id === currentId) return;
          openPanel(origCard);
        }, true);
      }
      // Append clones (giữ order)
      vis.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-bz-clone', '1');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        attachCloneClick(clone, card);
        grid.appendChild(clone);
      });
      // Prepend clones (insert reverse để giữ order phía trước vis[0])
      var firstOrig = vis[0];
      for (var i = vis.length - 1; i >= 0; i--) {
        var pc = vis[i].cloneNode(true);
        pc.setAttribute('data-bz-clone', '1');
        pc.setAttribute('aria-hidden', 'true');
        pc.removeAttribute('id');
        attachCloneClick(pc, vis[i]);
        grid.insertBefore(pc, grid.firstChild);
      }
      // Init: card đầu CANH GIỮA viewport (không phải canh mép trái) để trạng
      // thái mặc định giống lúc settle sau khi vuốt — trước đây lệch ~74px nên
      // cú vuốt đầu tiên bị "kéo bù" phần lệch đó.
      // Thử nhiều lần vì layout/ảnh chưa chắc xong ở frame đầu.
      var initTries = 0;
      var initIv = setInterval(function () {
        initTries++;
        invalidateCenters();
        var pos = grid.scrollLeft + snapCenterDeltaOf(firstOrig);
        if (pos > 0 || initTries > 10) {
          silentSetGrid(Math.max(0, Math.round(pos)));
          clearInterval(initIv);
          lastPct = 0;
          updateThumb();
        }
      }, 50);
      // Ảnh card load xong -> chiều rộng/vị trí đổi -> canh giữa lại, nhưng
      // CHỈ khi user chưa vuốt/bấm, để không giật ngang giữa lúc đang xem.
      function recenterIfIdle() {
        if (root._bzUserMoved) return;
        invalidateCenters();
        var p2 = grid.scrollLeft + snapCenterDeltaOf(firstOrig);
        if (p2 > 0) silentSetGrid(Math.round(p2));
        lastPct = 0;
        updateThumb();
      }
      window.addEventListener('load', function () { setTimeout(recenterIfIdle, 120); });
      Array.prototype.forEach.call(grid.querySelectorAll('img'), function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () {
          if (root._bzInvalidateGeo) root._bzInvalidateGeo();
          recenterIfIdle();
        });
      });
    }
    function origWidthForCat(cat) {
      var vis = visOrigCards(cat);
      if (!vis.length) return 0;
      var f = vis[0], l = vis[vis.length - 1];
      var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 0;
      return l.offsetLeft + l.offsetWidth - f.offsetLeft + gap;
    }
    function origStartForCat(cat) {
      var vis = visOrigCards(cat);
      if (!vis.length) return 0;
      return vis[0].offsetLeft - grid.offsetLeft;
    }
    var teleporting = false;
    function silentSetGrid(pos) {
      teleporting = true;
      var pbBhv = grid.style.scrollBehavior;
      var pbSnap = grid.style.scrollSnapType;
      grid.style.scrollBehavior = 'auto';
      grid.style.scrollSnapType = 'none';
      grid.scrollLeft = pos;
      void grid.offsetWidth;
      grid.style.scrollBehavior = pbBhv;
      grid.style.scrollSnapType = pbSnap;
      setTimeout(function () { teleporting = false; }, 50);
    }

    // ── Mobile (<1024px): 1 slide mỗi cú vuốt ────────────────────────────────
    // CSS scroll-snap không dùng được: infinite loop phải set scrollSnapType
    // 'none' vì snap fight với silent teleport. Nên chặn pan ngang native
    // (touch-action: pan-y) rồi tự xử: kéo theo ngón 1:1, thả ra settle về đúng
    // 1 card kế bên (canh giữa), hoặc về card cũ nếu vuốt chưa tới ngưỡng.
    // preventDefault khi đã xác định trục ngang cũng huỷ click của gesture đó
    // -> vuốt ngang không mở panel how-to ngoài ý muốn.
    var mqSnap = window.matchMedia('(max-width: 1023px)');
    function applySnapTouchMode() {
      if (grid) grid.style.touchAction = mqSnap.matches ? 'pan-y' : '';
    }
    applySnapTouchMode();
    if (mqSnap.addEventListener) mqSnap.addEventListener('change', applySnapTouchMode);
    else if (mqSnap.addListener) mqSnap.addListener(applySnapTouchMode);

    // ── Cache tâm card trong hệ toạ độ scroll ────────────────────────────────
    // Đo 1 lần mỗi layout rồi chỉ tính số học. Trước đây mỗi frame quét
    // getBoundingClientRect của mọi card instance (orig + clone) => forced
    // layout liên tục lúc vuốt. KHÔNG dùng offsetLeft vì offsetParent khác
    // grid -> lệch đúng bằng padding-left.
    var centerCache = null;
    function measureCenters() {
      var gr = grid.getBoundingClientRect();
      var base = gr.left - grid.scrollLeft; // gốc toạ độ scroll
      centerCache = [];
      Array.prototype.forEach.call(allCardInstances(), function (c) {
        if (!c.offsetWidth) return; // card của tab không active
        var r = c.getBoundingClientRect();
        centerCache.push({ el: c, center: r.left + r.width / 2 - base });
      });
      return centerCache;
    }
    function centers() { return centerCache || measureCenters(); }
    function invalidateCenters() { centerCache = null; }
    function snapViewCenter() { return grid.scrollLeft + grid.clientWidth / 2; }

    function snapCenterDeltaOf(card) {
      var list = centers(), view = snapViewCenter();
      for (var i = 0; i < list.length; i++) {
        if (list[i].el === card) return list[i].center - view;
      }
      var gr = grid.getBoundingClientRect();
      var cr = card.getBoundingClientRect();
      return (cr.left + cr.width / 2) - (gr.left + gr.width / 2);
    }
    function snapNearestCard() {
      var list = centers(), view = snapViewCenter();
      var best = null, bestDist = Infinity;
      for (var i = 0; i < list.length; i++) {
        var d = Math.abs(list[i].center - view);
        if (d < bestDist) { bestDist = d; best = list[i].el; }
      }
      return best;
    }
    // Settle sau khi thả ngón: easeOutCubic (nhanh ngay lúc thả rồi giảm dần).
    // smoothScrollBy dùng ease-in-out cho arrow — ở gesture thì đoạn chậm đầu
    // làm cảm giác giật vì ngón vừa rời màn hình với vận tốc lớn.
    function snapAnimBy(delta) {
      if (grid._bzAnim) cancelAnimationFrame(grid._bzAnim);
      var duration = 380, startT = null, start = grid.scrollLeft;
      var target = start + delta, lastLeft = start;
      function ease(t) { var u = 1 - t; return 1 - u * u * u; }
      function frame(ts) {
        if (startT === null) startT = ts;
        var pr = Math.min(1, (ts - startT) / duration);
        var jump = grid.scrollLeft - lastLeft;
        if (Math.abs(jump) > 100) { start += jump; target += jump; }
        var next = start + (target - start) * ease(pr);
        grid.scrollLeft = next;
        lastLeft = next;
        if (pr < 1) grid._bzAnim = requestAnimationFrame(frame);
        else grid._bzAnim = null;
      }
      grid._bzAnim = requestAnimationFrame(frame);
    }
    // Center `card` rồi dịch thêm `dir` bước; chuẩn hoá modulo cycle để chọn
    // instance gần nhất (không chạy ngược cả vòng khi card là clone ở xa).
    // `step`/`cycle` truyền từ cache của gesture — không đo lại giữa animate.
    function snapSettleTo(card, dir, step, cycle) {
      if (!card || !grid) return;
      var delta = snapCenterDeltaOf(card) + dir * (step || recStepSize());
      var w = cycle != null ? cycle
        : (hasClones() ? origWidthForCat(root.getAttribute('data-bz-cat') || 'vietnamese') : 0);
      if (w) {
        delta = ((delta % w) + w) % w;
        if (delta > w / 2) delta -= w;
      }
      snapAnimBy(delta);
    }

    if (grid) {
      var tStartX = 0, tStartY = 0, tLastX = 0, tStartT = 0, tAxis = '', tCard = null;
      var tPendingDX = 0, tRaf = null, tStep = 0, tCycle = 0;

      // Gộp mọi touchmove trong 1 frame thành ĐÚNG 1 lần ghi scrollLeft. Ngón
      // thật bắn ~2-3 touchmove/frame; ghi mỗi lần sẽ tạo 2-3 scroll event/frame
      // -> wrap check + updateThumb + syncActiveDot đọc offsetLeft của mọi card
      // nhiều lần trong 1 frame => forced layout, đó là chỗ giật.
      function flushDrag() {
        tRaf = null;
        if (!tPendingDX) return;
        grid.scrollLeft -= tPendingDX;
        tPendingDX = 0;
      }

      grid.addEventListener('touchstart', function (e) {
        if (!mqSnap.matches || !e.touches || e.touches.length !== 1) return;
        root._bzUserMoved = true;
        if (grid._bzAnim) { cancelAnimationFrame(grid._bzAnim); grid._bzAnim = null; }
        tStartX = tLastX = e.touches[0].clientX;
        tStartY = e.touches[0].clientY;
        tStartT = Date.now();
        tAxis = '';
        tPendingDX = 0;
        tCard = snapNearestCard();
        // Đo 1 lần cho cả gesture — layout không đổi giữa lúc vuốt.
        tStep = recStepSize();
        tCycle = hasClones() ? origWidthForCat(root.getAttribute('data-bz-cat') || 'vietnamese') : 0;
        centers(); // đo trước gesture để frame đầu không phải đo giữa lúc kéo
      }, { passive: true });

      grid.addEventListener('touchmove', function (e) {
        if (!mqSnap.matches || !e.touches || e.touches.length !== 1) return;
        var x = e.touches[0].clientX, y = e.touches[0].clientY;
        if (!tAxis) {
          var adx = Math.abs(x - tStartX), ady = Math.abs(y - tStartY);
          if (adx < 6 && ady < 6) return;
          tAxis = adx > ady ? 'x' : 'y';
        }
        if (tAxis !== 'x') return; // vuốt dọc -> để page scroll bình thường
        e.preventDefault();
        // Cộng dồn delta, KHÔNG tính lại từ tStartX: wrap teleport đổi
        // scrollLeft giữa gesture, tính lại từ start sẽ ghi đè teleport đó.
        tPendingDX += (x - tLastX);
        tLastX = x;
        if (!tRaf) tRaf = requestAnimationFrame(flushDrag);
      }, { passive: false });

      grid.addEventListener('touchend', function () {
        if (!mqSnap.matches || tAxis !== 'x') { tAxis = ''; return; }
        if (tRaf) { cancelAnimationFrame(tRaf); tRaf = null; }
        flushDrag();
        var dist = tLastX - tStartX;
        var dt = Math.max(1, Date.now() - tStartT);
        var dir = 0;
        // Qua ngưỡng khoảng cách HOẶC flick nhanh -> đi đúng 1 card.
        if (Math.abs(dist) > 40 || Math.abs(dist) / dt > 0.4) dir = dist < 0 ? 1 : -1;
        snapSettleTo(tCard, dir, tStep, tCycle);
        tAxis = '';
      });

      grid.addEventListener('touchcancel', function () {
        if (tRaf) { cancelAnimationFrame(tRaf); tRaf = null; }
        if (tAxis === 'x') snapSettleTo(tCard, 0, tStep, tCycle);
        tAxis = '';
      });
    }

    // ---- Progress thumb (loop-aware) + scrub ----
    // Claim element: bz-pdp-progress.js se bo qua, vi pct o day tinh theo vong loop
    // (chi tren dai originals), khong theo scrollWidth tong (co clones).
    if (dots) dots._bzProgress = true;
    var lastPct = 0;

    function hasClones() {
      return !!(grid && grid.querySelector('[data-bz-clone="1"]'));
    }
    // Dùng cache của wrap handler nếu có (root._bzGeo) — origWidthForCat gọi
    // getComputedStyle + đọc offsetLeft, mà updateThumb chạy mỗi frame lúc vuốt.
    function loopMetrics() {
      var cat = root.getAttribute('data-bz-cat') || 'vietnamese';
      if (root._bzGeo) return root._bzGeo(cat);
      return { w: origWidthForCat(cat), s: origStartForCat(cat) };
    }
    function thumbPct() {
      if (!grid) return 0;
      if (!hasClones()) {
        var max = grid.scrollWidth - grid.clientWidth;
        return max > 0 ? Math.max(0, Math.min(1, grid.scrollLeft / max)) : 0;
      }
      var m = loopMetrics();
      if (!m.w) return 0;
      var rel = (grid.scrollLeft - m.s) % m.w;
      if (rel < 0) rel += m.w;
      return rel / m.w;
    }
    function updateThumb() {
      if (!dots) return;
      var p = thumbPct();
      // Wrap 1 -> 0: tat transition de thumb khong truot nguoc qua ca track.
      if (Math.abs(p - lastPct) > 0.4) {
        dots.classList.add('is-nojump');
        dots.style.setProperty('--bz-thumb-pct', String(p));
        void dots.offsetWidth;
        requestAnimationFrame(function () {
          if (!dots.classList.contains('is-scrubbing')) dots.classList.remove('is-nojump');
        });
      } else if (Math.abs(p - lastPct) > 0.0005) {
        // Ghi CSS var là 1 style recalc; bỏ qua thay đổi dưới 0.05% (mắt không
        // thấy) để lúc vuốt không ghi mỗi frame.
        dots.style.setProperty('--bz-thumb-pct', String(p));
      } else {
        return;
      }
      dots.setAttribute('aria-valuenow', String(Math.round(p * 100)));
      lastPct = p;
    }

    if (dots) {
      var scrubbing = false;
      var thumbWidth = function () {
        var v = parseFloat(getComputedStyle(dots).getPropertyValue('--bz-thumb-w'));
        return isNaN(v) ? 44 : v;
      };
      var pctFromClientX = function (x) {
        var r = dots.getBoundingClientRect();
        var span = r.width - thumbWidth();
        if (span <= 0) return 0;
        return Math.max(0, Math.min(1, (x - r.left - thumbWidth() / 2) / span));
      };
      var scrubTo = function (p) {
        if (!grid) return;
        if (hasClones()) {
          var m = loopMetrics();
          if (!m.w) return;
          grid.scrollLeft = m.s + m.w * Math.min(0.9999, p);
        } else {
          var max = grid.scrollWidth - grid.clientWidth;
          grid.scrollLeft = max * p;
        }
        updateThumb();
      };
      dots.addEventListener('pointerdown', function (e) {
        if (dots.hidden) return;
        scrubbing = true;
        dots.classList.add('is-scrubbing');
        dots.classList.add('is-nojump');
        if (dots.setPointerCapture) {
          try { dots.setPointerCapture(e.pointerId); } catch (err) {}
        }
        scrubTo(pctFromClientX(e.clientX));
        e.preventDefault();
      });
      dots.addEventListener('pointermove', function (e) {
        if (!scrubbing) return;
        scrubTo(pctFromClientX(e.clientX));
        e.preventDefault();
      });
      ['pointerup', 'pointercancel'].forEach(function (evt) {
        dots.addEventListener(evt, function (e) {
          if (!scrubbing) return;
          scrubbing = false;
          dots.classList.remove('is-scrubbing');
          dots.classList.remove('is-nojump');
          if (dots.releasePointerCapture) {
            try { dots.releasePointerCapture(e.pointerId); } catch (err) {}
          }
        });
      });
      dots.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
        if (!dir || !grid) return;
        e.preventDefault();
        smoothScrollBy(grid, dir * recStepSize());
      });
    }

    if (grid) {
      var isDown = false, startX = 0, scrollLeft = 0, moved = 0;
      grid.addEventListener('mousedown', function (e) {
        root._bzUserMoved = true;
        isDown = true;
        moved = 0;
        startX = e.pageX - grid.offsetLeft;
        scrollLeft = grid.scrollLeft;
      });
      ['mouseleave', 'mouseup'].forEach(function (evt) {
        grid.addEventListener(evt, function () {
          isDown = false;
          if (moved > 6) root._bzDragged = true;
        });
      });
      grid.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - grid.offsetLeft;
        var delta = (x - startX) * 1.2;
        moved = Math.abs(delta);
        grid.scrollLeft = scrollLeft - delta;
      });
      // Cache hình học vòng loop theo cat: chỉ phụ thuộc layout, không phụ
      // thuộc scroll. origWidthForCat gọi getComputedStyle + đọc offsetLeft,
      // mà scroll handler chạy hàng chục lần mỗi gesture.
      var geoCat = '', geoW = 0, geoS = 0, geoDirty = true;
      function invalidateGeo() { geoDirty = true; invalidateCenters(); }
      function ensureGeo(cat) {
        if (!geoDirty && geoCat === cat) return;
        geoCat = cat;
        geoW = origWidthForCat(cat);
        geoS = origStartForCat(cat);
        geoDirty = false;
      }
      root._bzInvalidateGeo = invalidateGeo;
      root._bzGeo = function (cat) {
        ensureGeo(cat);
        return { w: geoW, s: geoS };
      };
      window.addEventListener('resize', invalidateGeo);
      window.addEventListener('load', invalidateGeo);

      var scrollRaf = null;
      grid.addEventListener('scroll', function () {
        // Bidirectional wrap
        if (!teleporting) {
          ensureGeo(root.getAttribute('data-bz-cat'));
          if (geoW) {
            if (grid.scrollLeft >= geoS + geoW) silentSetGrid(grid.scrollLeft - geoW);
            else if (grid.scrollLeft < geoS) silentSetGrid(grid.scrollLeft + geoW);
          }
        }
        // 1 rAF đang chờ là đủ: trước đây updateThumb chạy đồng bộ mỗi scroll
        // event và mỗi event xếp thêm 1 callback syncActiveDot.
        if (!scrollRaf) {
          scrollRaf = window.requestAnimationFrame(function () {
            scrollRaf = null;
            updateThumb();
            syncActiveDot();
          });
        }
      }, { passive: true });
    }

    updateScrollState('vietnamese');
    setupInfiniteForCat('vietnamese');
    updateThumb();

    var defaultCard = root.querySelector('.bz-pdp-recipes__card[data-bz-rec-cat="vietnamese"]:not([data-bz-clone])');
    if (defaultCard) openPanel(defaultCard, true);

    // Expose để tab switch handler gọi
    root._bzSetupInfinite = setupInfiniteForCat;
  }

  function boot() {
    document.querySelectorAll('[data-bz-pdp-recipes]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector('[data-bz-pdp-recipes]');
    if (r) initSection(r);
  });
})();

// v=1788742255

// v=1788771720

// v=1788778075

// v=1788778466

// v=1788778808

// v=1788778968

// v=1788944488

// v=1788961173

// v=1788961927

// v=1788963092

// v=1788963582
